import {
    createStructuredSelector
} from "reselect";
import { selectAdditionalAccountDetails } from "../../../Messaging/selectors";
const getHowItWorks = (state)=>(state.howItWorks);
const getHowItWorksData =(state)=>( getHowItWorks(state).howItWorksData)
export const howItWorksDerivedStates = createStructuredSelector({
    howItWorksDetails:getHowItWorksData,
    additionalAccountDetails:selectAdditionalAccountDetails
})